import { getCookie } from "./clubUtils";

var clubCode, htmlString;
var cookieName = "AAAClubCode";

var pathXSLURI = "/xslt/clubPhoneNumber.xslt";
var LBpathXSLURI = "/xslt/lightboxPhoneNumber.xslt";
var isLightbox = false;

function setContext(context) {
    if (context == "lightbox") {
        isLightbox = true;
        pathXSLURI = LBpathXSLURI;
    }
}

$(document).ready(function () {
    clubCode = getCookie(cookieName);
    if (clubCode != null && clubCode != "") {
        callClubProfileByClubCode(clubCode, pathXSLURI);
    } else {
    }
});

function callClubProfileByClubCode(clubCode, pathXSLURI) {
    var soapMessage =
        '<?xml version="1.0" encoding="utf-8"?>' +
        "<soap:Envelope " +
        'xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"> ' +
        "<soap:Body> " +
        "<ns0:getFormatted " +
        'xmlns:ns0="http://club.wcm.aaalife.com/"> ' +
        "<clubCode>" +
        clubCode +
        "</clubCode> " +
        "<pathXSLURI>" +
        pathXSLURI +
        "</pathXSLURI> " +
        "</ns0:getFormatted> " +
        "</soap:Body> " +
        "</soap:Envelope>";

    $.ajax({
        type: "POST",
        beforeSend: function (xhr) {
            xhr.setRequestHeader("SOAPAction", "");
        },
        contentType: 'text/xml; charset="utf-8"',
        url: "/CDSWebServices/ClubService?wsdl",
        data: soapMessage,
        dataType: "xml",
        error: function (xhr, textstatus) {
            alert(xhr);
        },
        success: function (xhr, textstatus) {
            htmlString = $(xhr).find("return").text();
            if (isLightbox) {
                $("#callUs .phoneNo").html(htmlString);
                //		Cufon.replace("#callUs .phoneNo");
            } else {
                $("#dynamicPhone").html(htmlString);
                //		Cufon.replace("#dynamicPhone .cufon");
            }
        },
    });
}
